import { useMemo } from 'react';
import useBrands from './useBrands';
import { Option } from '@/components/inputs/AutocompleteInput';
import { BrandApi } from '../models';

interface UseBrandsOptionsProps {
  search?: string;
  minLength?: number;
  page?: number;
  pageSize?: number;
}

const useBrandsOptions = ({
  search,
  minLength = 3,
  page = 1,
  pageSize = 5,
}: UseBrandsOptionsProps = {}) => {
  const shouldSearch = search && search.length >= minLength;

  const { brands, isLoading, error } = useBrands({
    search: shouldSearch ? search : '',
    page,
    pageSize: shouldSearch ? pageSize : 5,
  });

  const brandOptions: Option[] = useMemo(
    () =>
      brands.map((brand: BrandApi) => ({
        label: brand.name,
        data: brand.id,
      })),
    [brands]
  );

  return {
    brands,
    brandOptions,
    isLoading,
    error,
  };
};

export default useBrandsOptions;
